import { ProfitAndLossPeriodType, ReportOutputType } from '../constants/types';
import { cleanOffsetFromDate } from '../../../helpers/datesAndTime.helper';

interface ICustomDates {
  periodType: string;
  startDate: Date | null;
  endDate: Date | null;
  outputType?: string;
}

export const datesArr = [
  { title: 'Beginning of the Year', type: ProfitAndLossPeriodType.BEGINNING_OF_YEAR },
  { title: 'Last Year', type: ProfitAndLossPeriodType.LAST_YEAR, isDisabled: false },
  { title: 'Current Month', type: ProfitAndLossPeriodType.MONTHLY_REPORT },
  { title: 'Current Quarter', type: ProfitAndLossPeriodType.QUARTERLY_REPORT },
  { title: 'All Time', type: ProfitAndLossPeriodType.ALL_TIME },
  { title: 'Custom Date', type: ProfitAndLossPeriodType.CUSTOM, isCustom: true },
];

export const printIframe = (id: string): boolean => {
  const documentWithFrames = document as Document & { frames?: any };

  const iframe = documentWithFrames.frames
    ? (documentWithFrames.frames[id] as HTMLIFrameElement)
    : (document.getElementById(id) as HTMLIFrameElement);

  const iframeWindow = iframe.contentWindow || iframe;

  iframe.focus();
  (iframeWindow as Window).print();

  return false;
};

export const handleDownload = (data: string | URL | undefined, fileName?: string) => {
  if (data) {
    const a = document.createElement('a');
    if (typeof data === 'string') {
      a.href = data;
    }
    a.download = fileName || 'Profit & Loss';
    a.target = '_blank';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};
export const handleSetPeriodDates = (type: string, userCreateTime: Date, start?: any, end?: any) => {
  const currentDate = new Date();
  const previousYear = currentDate.getFullYear() - 1;
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const quarterStartDate = new Date(currentYear, Math.floor(currentMonth / 3) * 3, 1);
  const userCreateDate = new Date(userCreateTime);

  if (type === ProfitAndLossPeriodType.LAST_YEAR) {
    const lastYearEndDate = new Date(previousYear, 11, 31, 23, 59, 59);
    const lastYearStartDate = new Date(previousYear, 0, 1);
    const isCreateDateBeforeLastYear = userCreateDate < lastYearStartDate;
    return {
      startDate:
        isCreateDateBeforeLastYear
          ? lastYearStartDate
          : cleanOffsetFromDate(userCreateDate),
      endDate: cleanOffsetFromDate(lastYearEndDate),
    };
  }

  if (type === ProfitAndLossPeriodType.BEGINNING_OF_YEAR) {
    const begOfYearDate = new Date(currentYear, 0, 1);
    return {
      startDate: userCreateDate > begOfYearDate ? userCreateTime : cleanOffsetFromDate(begOfYearDate),
      endDate: cleanOffsetFromDate(currentDate),
    };
  }

  if (type === ProfitAndLossPeriodType.MONTHLY_REPORT) {
    return {
      startDate:
        userCreateDate > new Date(currentYear, currentMonth, 1)
          ? userCreateTime
          : cleanOffsetFromDate(new Date(currentYear, currentMonth, 1)),
      endDate: cleanOffsetFromDate(currentDate),
    };
  }

  if (type === ProfitAndLossPeriodType.QUARTERLY_REPORT) {
    return {
      startDate: userCreateDate > quarterStartDate ? userCreateTime : cleanOffsetFromDate(quarterStartDate),
      endDate: cleanOffsetFromDate(currentDate),
    };
  }

  if (type === ProfitAndLossPeriodType.ALL_TIME) {
    return {
      startDate: userCreateDate,
      endDate: cleanOffsetFromDate(currentDate),
    };
  }

  if (type === ProfitAndLossPeriodType.CUSTOM) {
    return {
      startDate: start,
      endDate: end,
    };
  }
  return { startDate: userCreateTime, endDate: new Date() };
};

export const getInitialFilterObject = (userCreateTime: Date) => {
  const getDatePeriod = handleSetPeriodDates(ProfitAndLossPeriodType.BEGINNING_OF_YEAR, userCreateTime) || {
    startDate: new Date(),
    endDate: new Date(),
  };
  return {
    outputType: ReportOutputType.PDF,
    period: {
      periodType: ProfitAndLossPeriodType.BEGINNING_OF_YEAR,
      ...getDatePeriod,
    },
  };
};

interface IProps {
  dates: { startDate: Date; endDate: Date };
  periodType: string;
  outputType?: string;
}

export const getFilterObject = ({ dates, periodType, outputType }: IProps) => ({
  outputType: outputType || ReportOutputType.PDF,
  period: {
    periodType,
    startDate: dates?.startDate || new Date(),
    endDate: dates?.endDate || new Date(),
  },
});

export const handleSetCustomDate = ({ periodType, startDate, endDate, outputType }: ICustomDates) => ({
  outputType: outputType || ReportOutputType.PDF,
  period: {
    periodType,
    startDate: startDate instanceof Date ? startDate?.toISOString() : startDate,
    endDate: endDate instanceof Date ? endDate?.toISOString() : endDate,
  },
});

export const isUserExistInPrevYear = (date: string | number | Date) => {
  const currentYear = new Date().getFullYear();
  const inputYear = new Date(date).getFullYear();

  return inputYear < currentYear;
};
